import { get } from '../../../utils/api';

export default {
  getCities: data => get({ url: 'city/list', data, ssr: true }),
  getUserCity: (data, headers) => get({ url: 'city/user-city', headers, data, ssr: true }),
};
